<div class="flip-population-primary-card-container">
  <app-primary-card
    paddingSize="medium"
    size="full"
    title="{{ 'FLI-P Population Graph' | translate }}"
  >
    <app-flip-population-graph></app-flip-population-graph>
  </app-primary-card>
</div>
